import { render, staticRenderFns } from "./PrioritySelector.vue?vue&type=template&id=44dd91c8&"
import script from "./PrioritySelector.vue?vue&type=script&lang=js&"
export * from "./PrioritySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports